import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from 'react-router-dom';
import BlurLoader from "./components/CommonComponents/BlurFullPageLoader";
import { deleteCookie, logout } from "./components/CommonComponents/EnvConfig";
import { GetSession, RemoveSession } from "./components/CommonComponents/criptoUtils";
import Header from "./components/Layout/Header";
import Sidebar2 from './components/Layout/Sidebar';

const Protected = (Props) => {
    const { Component, path } = Props;
    const navigate = useNavigate();
    const location = useLocation();
    const [auth, setAuth] = useState(true);
    const subLoading = useSelector(state => state.auth.loading)
    const { open } = useSelector((state) => state.header);
    const sideBarHeader = [
        "/Print/LabelPrint",
    ];
    const hideLayout = sideBarHeader.includes(location.pathname);
    const checkLogin = async () => {
        const user = GetSession('cookies', 'clientUser');
        if (!user?.token || user?.token === 'EXPIRED') {
            RemoveSession('cookies', 'user')
            deleteCookie('user')
            logout()
            navigate('/');
            setAuth(false);
        } else {
            setAuth(true);
        }
    };

    useEffect(() => {
        checkLogin();
    }, [])

    return auth ? (
        <>

            {!hideLayout && <Sidebar2 />}
            <main
                id="main"
                className={`transition-all ease-in ${!hideLayout && open ? 'md:ms-[250px]' : 'md:ms-[0rem]'
                    }`}
            >
                {!hideLayout && <Header />}
                <div className='p-3'>
                    <Component />
                </div>
            </main>

            {subLoading && <BlurLoader />}
        </>
    ) : <></>

}
export default Protected